"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VXStrategyV1Contract = void 0;
const ContractFacade_1 = require("./abstact/ContractFacade");
const VXStrategyV1ABI_1 = require("./abi/VXStrategyV1ABI");
class VXStrategyV1Contract extends ContractFacade_1.ContractFacade {
    constructor(address, web3) {
        super(address, web3, VXStrategyV1ABI_1.VXStrategyV1ABI.GetABI());
    }
    getStrategy(ofAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            return this._call("strategies", ofAddress);
        });
    }
    getConfig(ofAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this._call("configs", ofAddress);
            if (!result)
                return;
            result.swapMaxSlippageIndex = this._toDecimal(result.swapMaxSlippageIndex);
            result.swapFrequencySeconds = parseInt(result.swapFrequencySeconds);
            result.splitFrequencySeconds = parseInt(result.splitFrequencySeconds);
            result.splitMinProfitAmount = this._toDecimal(result.splitMinProfitAmount);
            result.maxGasAmount = this._toDecimal(result.maxGasAmount);
            return result;
        });
    }
    configAsync(scope) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this._send('config', [
                "0",
                this._toWei(scope.uPLSInStake),
                "0",
                "0",
                scope.swapRouterV2,
                scope.swapPath,
                this._toWei(scope.swapMinPLSAmount),
                this._toWei(scope.swapMaxPLSAmount),
                this._toWei(scope.sendPLSIndex),
                scope.sendPLSReceiver,
                this._toWei(scope.bnsIndex),
                scope.sendAddress,
                scope.isBurnWithERC20Burn
            ]);
            return result;
        });
    }
    configureBotAsync(config) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this._send('configureBot', [
                this._toWei(config.swapMaxSlippageIndex),
                config.swapFrequencySeconds + "",
                config.splitFrequencySeconds + "",
                this._toWei(config.splitMinProfitAmount),
                this._toWei(config.maxGasAmount)
            ]);
            return result;
        });
    }
}
exports.VXStrategyV1Contract = VXStrategyV1Contract;
//# sourceMappingURL=VXStrategyV1Contract.js.map